module.exports = __webpack_public_path__ + "static/media/shopping-gray.005f2d21.svg";